<template>
  <table class="prompts">
    <thead>
      <tr>
        <th class="fave">
          <span class="fas fa-heart"></span>
        </th>
        <th class="username">Username</th>
        <th class="fandom">Fandoms</th>
        <th class="prompts">Prompts</th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="(prompt, index) in prompts" :key="index">
        <td>
          <button class="bookmark" @click="togglePromptmark(prompt)">
            <span v-if="hasPromptmark(prompt)" class="fas fa-heart"></span>
            <span v-else class="far fa-heart"></span>
          </button>
        </td>
        <td>
          {{ prompt.username }}
          <a @click="getUserPrompts(prompt.username)">(see all)</a>
        </td>
        <td class="characters">
          <ul class="characters" v-if="prompt.fandom">
            <li v-for="c in prompt.fandom" :key="c">{{ c }}</li>
          </ul>
        </td>
        <td class="prompt">
          <div v-html="prompt.prompt"></div>
          <a v-if="prompt.letter" :href="formatUrl(prompt.letter)" target="blank">Letter</a>
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script>
import { mapGetters } from "vuex";
import utils from "../utils.js";

export default {
  props: {
    fandomKey: {
      type: String,
      default: ""
    },
    prompts: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  computed: {
    ...mapGetters(["options", "promptmarks", "bookmarks"])
  },
  methods: {
    ...utils
  }
};
</script>